<app-header class="header-container" [locales]="availableLocales" [selectedLang]="selectedLang" (selectLang)="switchLanguage($event)"></app-header>

<div class="content">
    <div class="home">
    <div class="pub">
        <div class="l-pub" style="background-image: url(images/jpg/pub_1.jpg);"></div>
        <div class="r-pub" style="background-image: url(images/jpg/pub_2.jpg);"></div>
    </div>
    <div class="panel">
        <app-meeting [locale]="currentLocale" [meetings]="meetings" [selectedMeetingId]="pari.meeting?.id" (reunionSelected)="updateBetMeeting($event)"></app-meeting>
        <app-race [races]="races" [selectedRaceId]="pari.race?.id" (raceSelected)="updateBetRace($event)"></app-race>
        <app-game-selection [games]="games" (selectedGameCode)="completeGameSelection($event)"></app-game-selection>
    </div>
</div>
</div>

